import React, { useState } from 'react';
import { Icon, Modal, Button } from 'semantic-ui-react';
import { makePlural } from 'src/utils/useful_functions';
import PermissionsPanel from './PermissionsPanel';
import { useIntl } from 'react-intl';
import messages from 'src/messages';
import { useQueryClient } from '@tanstack/react-query';
import { PROJECTS_QUERY_KEY } from './ProjectListItems';

const ShareDialog = ({
  projectId,
  projectName,
  initialUserNames = [],
  isAdmin = false,
}) => {
  const { formatMessage } = useIntl();
  const [open, setOpen] = useState(false);
  const [users, setUsers] = useState(
    initialUserNames.map((name) => ({ name, permission: 'Read' }))
  );
  const [newUser, setNewUser] = useState('');
  const [newPermission, setNewPermission] = useState('Read');
  const qc = useQueryClient();

  const handleAddUser = () => {
    if (newUser.trim() && !users.find((u) => u.name === newUser)) {
      setUsers([...users, { name: newUser, permission: newPermission }]);
      setNewUser('');
      setNewPermission('Read');
    }
  };

  const handlePermissionChange = (index, value) => {
    const updatedUsers = [...users];
    updatedUsers[index].permission = value;
    setUsers(updatedUsers);
  };

  const handleRemoveUser = (index) => {
    setUsers(users.filter((_, i) => i !== index));
  };

  const handleClose = () => {
    setOpen(false);
    qc.invalidateQueries({ queryKey: PROJECTS_QUERY_KEY });
  };

  const otherUserQty = users.length - 1;
  let title = 'Share project';
  if (users.length > 1) {
    title = `Shared with ${otherUserQty} ${makePlural(
      otherUserQty,
      'user',
      'users'
    )}`;
  }
  if (!isAdmin) {
    title = 'You need admin permissions to share this project';
  }

  const iconColor = users.length > 1 ? 'blue' : undefined;

  return (
    <>
      <Icon
        name="share alternate"
        link
        disabled={!isAdmin}
        color={iconColor}
        onClick={() => setOpen(true)}
        title={title}
      />
      <Modal open={open} onClose={() => setOpen(false)} size="small">
        <Modal.Header>
          Project Permissions: {projectName}
          <Button
            circular
            icon="close"
            title="Close"
            floated="right"
            onClick={() => setOpen(false)}
          />
        </Modal.Header>
        <Modal.Content>
          <PermissionsPanel projectId={projectId} isAdmin={isAdmin} />
        </Modal.Content>
        <Modal.Actions>
          <Button color="blue" onClick={handleClose}>
            {formatMessage(messages.ok)}
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
};

export default ShareDialog;
